import Header from './components/Header';
import Footer from './components/Footer';
import FloatingSocialRail from './components/FloatingSocialRail';
import FloatingCTARail from './components/FloatingCTARail';
import HeroSection from './sections/HeroSection';
import FeaturesSection from './sections/FeaturesSection';
import StorySection from './sections/StorySection';
import StaffSection from './sections/StaffSection';
import CampaignSection from './sections/CampaignSection';
import { RegisterModalProvider } from './contexts/RegisterModalContext';

export default function App() {
  return (
    <RegisterModalProvider>
      {/* Single page-level <h1> = the game name, visually hidden (the
          hero renders the logo image instead). Gives crawlers + screen
          readers one clear primary heading; the section titles below
          stay <h2>. */}
      <h1 className="sr-only">
        I Love Cooking ฟาร์มร้านในฝัน — I Love Cooking : Dream Farm
      </h1>
      <Header />
      <FloatingSocialRail />
      <FloatingCTARail />
      <main className="bg-[#634645]">
        <HeroSection />
        {/* <RegisterSection /> */}
        <StorySection />
        <FeaturesSection />
        <StaffSection />
        <CampaignSection />
      </main>
      {/* Footer wrapper — `snap-end` (`scroll-snap-align: end`)
          makes the footer its own snap target on mobile (no-op at
          md+ where `<html>` has `scroll-snap-type: none`). When
          mandatory snap settles on phones, the footer's BOTTOM
          edge aligns with the viewport's BOTTOM edge, so the
          screen shows: [bottom of CampaignSection content] +
          [full footer] in one snapped view — exactly matching
          the "include footer as part of last snap screen of
          Campaign" requirement. */}
      <div className="snap-end bg-[#F6ebd6]">
        <Footer />
      </div>
    </RegisterModalProvider>
  );
}
